import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import FoundationLayout from '../components/layout/FoundationLayout';
import ShortNotesPage from '../components/IITDashboard/short-notes';
import { getFoundationStudent } from '../foundationSession';

/**
 * IIT Foundation Short Notes — filtered to the logged-in student's class, and the
 * subject dropdown shows only the subjects taught in that class (getFoundationSubjects).
 * All from the in-memory session; no cookies/localStorage.
 */
const FOUNDATION_SUBJECTS = gql`
  query($class_id: Int!) {
    getFoundationSubjects(class_id: $class_id) { id name }
  }
`;

class IITFoundationShortNotes extends Component {
    render() {
        const student = getFoundationStudent() || {};
        const subjectRows = (this.props.foundationSubjects || {}).getFoundationSubjects || [];
        const subjects = subjectRows.map((s) => s.name);

        return (
            <FoundationLayout student={student}>
                <ShortNotesPage
                    classId={student.grade_id != null ? student.grade_id : null}
                    classValue={student.class_num || undefined}
                    registrationId={student.id != null ? student.id : null}
                    subjects={subjects.length ? subjects : undefined}
                />
            </FoundationLayout>
        );
    }
}

export default graphql(FOUNDATION_SUBJECTS, {
    name: "foundationSubjects",
    skip: () => { const s = getFoundationStudent(); return !(s && s.grade_id); },
    options: () => {
        const s = getFoundationStudent();
        return { variables: { class_id: Number(s.grade_id) }, fetchPolicy: "cache-and-network" };
    },
})(IITFoundationShortNotes);
